import { Button, Container, RadioGroup, FormControlLabel, Radio, Typography, Grid, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useEffect, useState } from 'react';
import * as azblob from '@azure/storage-blob';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const DigiKunsForm = (props) => {

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }
        else {
            setInskrywingInfo({ ...inskrywing, "inskrywerId": props.userProf.userProfile.id })
        }

    }, [])

    const classes = useStyles();
    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [kuns, setKuns] = useState("GEEN");
    const [pdf, setPdf] = useState("GEEN");
    const [bewyse, setBewyse] = useState("GEEN");
    const [kunsOpgelaai, setKunsOpgelaai] = useState(false);
    const [pdfOpgelaai, setPdfOpgelaai] = useState(false);
    const [bewyseOpgelaai, setBewyseOpgelaai] = useState(false)
    const [formIsInValid, setFormIsInvalid] = useState(true);
    const [isBemagtig, setIsBemagtig] = useState(true);
    const [inskrywing, setInskrywingInfo] = useState({
        "inskrywerId": "",
        "naamVan": "",
        "ouerNaamVan": "",
        "ouerSel": "",
        "ouerEpos": "",
        "sel": "",
        "epos": "",
        "kategorie": "",
        "ouerBemagtigingGegee": false,
        "nodigOuer": true,
        "kunsGelaai": false,
        "pdfGelaai": false,
        "gedigOorsprong": "",
        "kunsmedium": "",
        "bewyseGelaai": false
    });
    const [inskrywingId, setInskrywingId] = useState();

    const style = {

        padding: "20px",
    }

    const accountName = "projektestorage";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    const containerName = "digikuns";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    //const fileList = document.getElementById("file-list");
    const kunsInput = document.getElementById("kunswerk-input");
    const pdfInput = document.getElementById("pdf-input");
    const bewyseInput = document.getElementById("bewyse-input");


    const formChange = (e) => {
        if (e.target.type === "radio") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.value });
        }
        else if (e.target.type === "checkbox") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.checked });

        }
        else {
            setInskrywingInfo({ ...inskrywing, [e.target.id]: e.target.value });
        }
    }

    const finishRegistration = async () => {
        //start upload ui
        setIsUploading(true);
        //insert record for inskrywing into db
        fetch('api/UserEntries/digikuns/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(inskrywing)
        })
            .then((response) => response.json())
            .then((data) => {
                setInskrywingId(data.id);
               
                //console.log('data logged as reposne', data);
            })

    }

    const pdfInputChanged = () => {
        if (document.getElementById("pdf-input").value != "") {
            setPdf("Gedig gekies!");
            setPdfOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "pdfGelaai": true })
        }
        else {
            setPdf("");
            setPdfOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "pdfGelaai": false })


        }

    }

    const artFileInputChanged = () => {
        if (document.getElementById("kunswerk-input").value != "") {
            setKuns("Kunswerk gekies!");
            setKunsOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "kunsGelaai": true })
        }
        else {
            setKuns("");
            setKunsOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "kunsGelaai": false })


        }

    }

    const bewyseInputChange = () => {
        if (document.getElementById("bewyse-input").value != "") {
            setBewyse("Bewyse van betaling gekies!");
            setBewyseOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": true })
        }
        else {
            setBewyse("");
            setBewyseOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": false })


        }

    }



    const uploadVidToBlob = async () => {
        //await finishSubmit();
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of pdfInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.naamVan + "-" + inskrywing.inskrywerId + "-inskrywing-pdf-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        for (const file of kunsInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.naamVan + "-" + inskrywing.inskrywerId + "-inskrywing-kunswerk-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        for (const file of bewyseInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.naamVan + "-" + inskrywing.inskrywerId + "-inskrywing-bewyse-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        await Promise.all(promises);
        reportStatus("Sukses!");
        setIsUploading(false);
        window.setTimeout(props.history.push('suksesinskryf'), 1000);
    }


    //unneccessary for production
    useEffect(() => {
        //console.log('loigging props on digipraatform', props);
        console.log('logging inskrywing state', inskrywing);
    }, [])

    useEffect(() => {
        if (inskrywingId !== undefined) {
            //wait for id to be returned before uploading video to azureblob
            //window.alert('BEGIN VIDEOMATERIAAL LAAI, ASSEBLIEF WEES GEDULDIG');
            uploadVidToBlob();
        }
    }, [inskrywingId])

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }

    }, [])

    useEffect(() => {
        //as inskrywing verander, kyk of vorm leeg is

        //console.log('Inskrywing:', inskrywing);
        var isValid = true;

        for (var property in inskrywing) {
            if (property === "ouerBemagtigingGegee") {
                if (inskrywing["ouerBemagtigingGegee"] === false) {
                    isValid = false;
                }
            }
            else if (property === "kunsGelaai") {
                if (inskrywing["kunsGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (property === "pdfGelaai") {
                if (inskrywing["pdfGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (property === "bewyseGelaai") {
                if (inskrywing["bewyseGelaai"] === false) {
                    isValid = false;
                }
            }

            //else if (inskrywing[property] === "kategorie") {
            //    if (["58j", "912j", "1318j"].includes(inskrywing["kategorie"])
            //        && [inskrywing["ouerNaamVan"], inskrywing["ouerSel"], inskrywing["ouerEpos"]].includes("")) {
            //        isValid = false;
            //    }

            //}
            else if (inskrywing[property] === "") {
                if (property === "ouerNaamVan" || property === "ouerSel" || property === "ouerEpos") {
                    if (!["1925j", "v26", "sb60"].includes(inskrywing["kategorie"])) {
                        isValid = false;
                    }
                }
                else {
                    isValid = false;
                }
            }

            //console.log(`key= ${property} value = ${inskrywing[property]}`)
        }
        if (isValid) {
            setFormIsInvalid(false);
        }
        else {
            setFormIsInvalid(true);
        }


    }, [inskrywing])


    return (
        <Container className="container" style={style}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Deelnemerbesonderhede </Typography>

                    <TextField onChange={formChange} id="naamVan" required label="Naam en van" variant="outlined" margin="normal" fullWidth />

                    <Typography variant="h5" gutterBottom>Kategorie</Typography>
                    <RadioGroup name="kategorie" aria-label="kategorie" onChange={formChange}>
                        <Grid item xs={12}>
                            {/* 
                              9-12 jaar / 13-18 jaar / 19-25 jaar / Volwassenes (26+ jaar) /  Senior burgers (60+ jaar)
                                */}
                            <FormControlLabel value="58j" control={<Radio color="primary" />} label="5-8 jaar" />
                            <FormControlLabel value="912j" control={<Radio color="primary" />} label="9-12 jaar" />
                            <FormControlLabel value="1318j" control={<Radio color="primary" />} label="13-18 jaar" />
                            <FormControlLabel value="1925j" control={<Radio color="primary" />} label="19-25 jaar" />
                            <FormControlLabel value="v26" control={<Radio color="primary" />} label="Volwassenes (26+ jaar)" />
                            <FormControlLabel value="sb60" control={<Radio color="primary" />} label="Senior burgers (60+ jaar)" />
                        </Grid>
                    </RadioGroup>

                    <TextField onChange={formChange} id="sel"  label="Selfoonnommer" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="epos"  label="E-posadres" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerNaamVan"  label="Ouer/Voog naam en van (deelnemers jonger as 18)" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerSel" label="Ouer/Voog selfoonnommer (deelnemers jonger as 18)" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerEpos" label="Ouer/Voog e-posadres (deelnemers jonger as 18)" variant="outlined" margin="normal" type="email" fullWidth />

                    <Typography variant="h5" gutterBottom>Vrywaring</Typography>
                    <Grid container>
                        <Grid item xs={2} lg={2}>
                            <Checkbox
                                onChange={formChange}
                                color="primary"
                                name="ouerBemagtigingGegee"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={10} lg={10}>
                            <Typography variant="h6" gutterBottom>
                                {
                                    //important notice to be ticked
                                }
                        Hiermee gee ek, as deelnemer / ouer of voog, toestemming dat die gedig en kunswerk ingeskryf, gebruik mag word vir bemarkingsdoeleindes. Deur in te skryf, verbind ek my tot die reëls onderhewig aan die DigiKuns-deelnemersgids.
                            </Typography>
                        </Grid>
                    </Grid>


                </Grid>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Gedig en Kunswerk</Typography>

                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Gedig-oplaaifunksie</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Kies gedig
                        <input
                                id="pdf-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={pdfInputChanged}
                                accept=".pdf, .jpg, .png, image/*"

                            />
                        </Button>
                        {pdfOpgelaai ? <p> {pdf} </p> : <p> </p>}

                    </div>

                    <Typography variant="h5" gutterBottom>Oorsprong van gedig</Typography>
                    <RadioGroup name="gedigOorsprong" aria-label="kategorie" onChange={formChange}>
                        <Grid item xs={12}>
                            <FormControlLabel value="gepubliseerde" control={<Radio color="primary" />} label="Gepubliseerde Afrikaanse Gedig" />
                            <FormControlLabel value="selfgeskrewe" control={<Radio color="primary" />} label="Selfgeskrewe" />
                        </Grid>
                    </RadioGroup>


                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Kunswerk-oplaaifunksie – sien gids vir kunswerkspesifikasies</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Kies kunswerk
                        <input
                                id="kunswerk-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={artFileInputChanged}
                                accept=".pdf, .jpg, .png, image/*"

                            />
                        </Button>
                        {kunsOpgelaai ? <p> {kuns} </p> : <p> </p>}

                    </div>
                    {/* 
                     * Bewys van betaling
                     */}
                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Bewys van betaling</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Betalingsoplaaifunksie
                        <input
                                id="bewyse-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={bewyseInputChange}
                                accept=".pdf"

                            />
                        </Button>
                        {bewyseOpgelaai ? <p> {bewyse} </p> : <p> </p>}

                    </div>
                    {/* 
                     * END Bewys van betaling END
                     */}

                    <Typography variant="h5" gutterBottom>Kunsmedium</Typography>
                    <RadioGroup name="kunsmedium" aria-label="afdeling" onChange={formChange}>
                        <FormControlLabel value="verf" control={<Radio color="primary" />} label="Verf" />
                        <FormControlLabel value="teken" control={<Radio color="primary" />} label="Teken" />
                        <FormControlLabel value="collage" control={<Radio color="primary" />} label="Collage" />
                        <FormControlLabel value="beeldhouwerk" control={<Radio color="primary" />} label="Beeldhouwerk" />
                        <FormControlLabel value="fotografie" control={<Radio color="primary" />} label="Fotografie" />
                        <FormControlLabel value="digitaleillustrasie" control={<Radio color="primary" />} label="Oorspronklike digitale illustrasie" />
                    </RadioGroup>

                </Grid>
                <Grid container justify="center">
                    {isUploading ? <Grid item> <CircularProgress /> <Typography variant="body1" gutterBottom>{status}</Typography> </Grid> : <br />}
                </Grid>

                <Grid container justify="center">
                    <Grid>
                        <Button variant="contained" size="large" color="primary" disabled={formIsInValid} onClick={finishRegistration}>Registreer vir ATKV-DigiKuns</Button>

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )

}


export default DigiKunsForm;


// WEBPACK FOOTER //
// ./src/components/inskrywingsvorms/DigiKunsForm.js